module.exports = __webpack_public_path__ + "static/img/facebook_white.707d1ec0.svg";